import { useTranslation } from "react-i18next";
import { Card, Icon, Popup } from "semantic-ui-react";

import "modules/WarrantyDashboard/components/WarrantyDashboardTable/components/LocationInfo/LocationInfo.scss";

import type { Dealer, DealerLocation } from "models";

type LocationCardProps = {
  dealers: Dealer[];
  locations: DealerLocation[];
  dealerLocationId: number;
};

export const DealerLocationCard = ({ dealerLocationId, locations, dealers }: LocationCardProps) => {
  const { t } = useTranslation();

  const location = locations.find(dealerLocation => dealerLocation.id === dealerLocationId);
  const dealer = dealers.find(element => element.id === location?.dealer_id);

  return (
    <Card className="WarrantyLocationInfo__location-info-card-no-box-shadow">
      <Card.Content>
        <Card.Meta className="WarrantyLocationInfo__dealer-location-title">{t("v8_dealer_location", "Dealer/Location")}</Card.Meta>
        {dealer?.name && <Card.Description content={dealer.name} />}
        {location?.name && <Card.Description content={location.name} />}
      </Card.Content>
    </Card>
  );
};

export const LocationCard = ({ dealerLocationId, locations, dealers }: LocationCardProps) => (
  <Popup
    on="hover"
    content={<DealerLocationCard dealerLocationId={dealerLocationId} locations={locations} dealers={dealers} />}
    trigger={
      <div className="WarrantyLocationInfo__location-info-card-container">
        <div className="WarrantyLocationInfo__location-info-card-user">
          <Icon className="house chimney" />
        </div>
      </div>
    }
  />
);
